import RestApi from './../../api/automation-api-client'

const srvcEndpoint = '/leaderboards/enrolled'

export default {
  // Recruiters in the viewer's downline ranked by agents enrolled between
  // start & stop (YYYY-MM-DD). The downline is resolved server-side.
  get: async (start, stop) => RestApi.request('GET', srvcEndpoint, { query: { start, stop } }),
}
